import React from 'react';
import { AlertTriangleIcon, LockIcon, ZapIcon, TargetIcon, DropletIcon, FlameIcon, BatteryIcon, ChevronRightIcon, CameraIcon, StarIcon } from 'lucide-react';
export function RecommendationsPage() {
  return <div className="min-h-screen bg-[#0d0d0d] text-white font-sans selection:bg-[#b91c1c] selection:text-white" data-id="element-960">
      {/* Top Nav Bar (matching other pages) */}
      <header className="bg-[#002868] text-white w-full" data-id="element-961">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 h-12 flex items-center justify-between" data-id="element-962">
          <div className="flex items-center gap-2 font-bold text-lg tracking-tight" data-id="element-963">
            <StarIcon className="w-5 h-5 fill-current text-[#b91c1c]" data-id="element-964" />
            <span data-id="element-965">PatriotsInformer</span>
          </div>
        </div>
      </header>

      {/* Hero Section */}
      <section className="relative py-8 px-4 text-center bg-[#0a0a0a] overflow-hidden" data-id="element-966">
        {/* Subtle vertical stripes background effect */}
        <div className="absolute inset-0 opacity-5" style={{
        backgroundImage: 'repeating-linear-gradient(90deg, transparent, transparent 40px, rgba(255,255,255,0.1) 40px, rgba(255,255,255,0.1) 80px)'
      }} data-id="element-967"></div>

        <div className="relative z-10 max-w-3xl mx-auto space-y-6" data-id="element-968">
          <p className="text-[#c5a059] text-xs font-bold tracking-[0.2em] uppercase" data-id="element-969">
            Patriots Informer · Trusted Resources
          </p>
          <h1 className="text-4xl md:text-7xl font-black tracking-tighter uppercase text-white leading-none" data-id="element-970">
            Jack's Picks
          </h1>
          <p className="text-gray-400 text-lg md:text-xl italic font-serif max-w-2xl mx-auto leading-relaxed" data-id="element-971">
            Every resource here has been hand-selected because it gives real,
            actionable knowledge, not theory. These are the tools I'd want my
            family to have before the lights go out.
          </p>
        </div>
      </section>

      {/* Red Banner */}
      <div className="bg-[#d92b2b] text-white py-3 px-4 text-center" data-id="element-972">
        <p className="text-sm md:text-base font-bold tracking-wider uppercase flex items-center justify-center gap-2" data-id="element-973">
          <AlertTriangleIcon className="w-4 h-4 flex-shrink-0" data-id="element-974" />
          Real preparedness covers three things: Water, Food, and Energy. I've
          got you covered on all three.
        </p>
      </div>

      {/* Trust Badges */}

      {/* Main Content */}
      <main className="max-w-5xl mx-auto px-4 py-8 space-y-12" data-id="element-975">
        {/* Section Header */}
        <div className="space-y-2" data-id="element-976">
          <p className="text-[#c5a059] text-xs font-bold tracking-[0.2em] uppercase" data-id="element-977">
            My Recommendations
          </p>

          <div className="w-16 h-1 bg-[#c5a059]" data-id="element-978"></div>
        </div>

        {/* Cards Container */}
        <div className="space-y-8" data-id="element-979">
          {/* Card 1: Smart Water Box (Full Width) */}
          <div className="bg-[#1a1a1a] border border-[#333] flex flex-col relative group" data-id="element-980">
            {/* Left Border Accent */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#c5a059]" data-id="element-981"></div>

            {/* Title Area - Above Image */}
            <div className="p-6 md:p-8 pb-4 md:pb-4 relative" data-id="element-982">
              {/* Badge */}
              <div className="absolute top-0 right-0 bg-[#d92b2b] text-white text-[10px] font-bold tracking-widest uppercase px-3 py-1" data-id="element-983">
                Editor's Pick
              </div>
              <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase mb-2" data-id="element-984">
                <DropletIcon className="w-3 h-3 fill-current text-[#3b82f6]" data-id="element-985" />
                <span data-id="element-986">Water Survival</span>
              </div>
              <h3 className="text-2xl md:text-3xl font-black tracking-tight uppercase" data-id="element-987">
                Smart Water Box
              </h3>
            </div>

            {/* Image + Content Row */}
            <div className="flex flex-col md:flex-row" data-id="element-988">
              {/* Image Area */}
              <div className="w-full md:w-2/5 bg-[#111827] min-h-[250px] flex items-center justify-center border-y md:border-y-0 md:border-r border-[#333]" data-id="element-989">
                <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-990">
                  <CameraIcon className="w-6 h-6" data-id="element-991" />
                  <span className="text-xs font-bold tracking-widest" data-id="element-992">
                    IMAGE HERE
                  </span>
                </div>
              </div>

              {/* Content Area */}
              <div className="w-full md:w-3/5 p-6 md:p-8 flex flex-col justify-between relative" data-id="element-993">
                <div className="space-y-4" data-id="element-994">
                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-995">
                    When the tap runs dry — whether from a grid failure, natural
                    disaster, or supply disruption — most families have no plan.
                    The Smart Water Box gives you a real one. A compact, proven
                    system to collect, filter, and store clean drinking water on
                    demand, anywhere.
                  </p>

                  <ul className="space-y-2 text-sm text-gray-300" data-id="element-996">
                    <li className="flex items-start gap-2" data-id="element-997">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-998">
                        ▶
                      </span>
                      <span data-id="element-999">Works without running water or electricity</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1000">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1001">
                        ▶
                      </span>
                      <span data-id="element-1002">Enough clean water for a family of 4</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1003">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1004">
                        ▶
                      </span>
                      <span data-id="element-1005">Easy to build with common materials</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1006">
                  <div data-id="element-1007">
                    <div className="text-xl font-bold" data-id="element-1008">Watch Free Video</div>
                    <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1009">
                      Limited Availability
                    </div>
                  </div>
                  <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1010">
                    Watch Now <ChevronRightIcon className="w-4 h-4" data-id="element-1011" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* 2 Column Grid */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-1012">
            {/* Card 2: The Lost Superfoods */}
            <div className="bg-[#1a1a1a] border border-[#333] flex flex-col relative group" data-id="element-1013">
              {/* Top Border Accent */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-[#c5a059]" data-id="element-1014"></div>

              {/* Image Area */}
              <div className="w-full bg-[#1c1a11] aspect-[4/3] flex items-center justify-center border-b border-[#333]" data-id="element-1015">
                <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1016">
                  <CameraIcon className="w-6 h-6" data-id="element-1017" />
                  <span className="text-xs font-bold tracking-widest" data-id="element-1018">
                    IMAGE HERE
                  </span>
                </div>
              </div>

              {/* Content Area */}
              <div className="p-6 md:p-8 flex flex-col flex-1 justify-between" data-id="element-1019">
                <div className="space-y-4" data-id="element-1020">
                  <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase" data-id="element-1021">
                    <FlameIcon className="w-3 h-3 fill-current text-[#f97316]" data-id="element-1022" />
                    <span data-id="element-1023">Food Storage</span>
                  </div>

                  <h3 className="text-2xl font-black tracking-tight uppercase" data-id="element-1024">
                    The Lost Superfoods
                  </h3>

                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1025">
                    126 forgotten foods your grandparents knew how to preserve —
                    without refrigeration, without electricity, and for years at
                    a time. From the US Army's Cold War ration to Viking-era
                    preservation secrets, this is the food knowledge the modern
                    world buried.
                  </p>

                  <ul className="space-y-2 text-sm text-gray-300" data-id="element-1026">
                    <li className="flex items-start gap-2" data-id="element-1027">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1028">
                        ▶
                      </span>
                      <span data-id="element-1029">Store food for years without a fridge</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1030">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1031">
                        ▶
                      </span>
                      <span data-id="element-1032">Build a full stockpile for under $5/week</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1033">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1034">
                        ▶
                      </span>
                      <span data-id="element-1035">Color photos, step-by-step instructions</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1036">
                  <div data-id="element-1037">
                    <div className="text-xl font-bold" data-id="element-1038">$37</div>
                    <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1039">
                      Physical + Digital Book
                    </div>
                  </div>
                  <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1040">
                    Get The Book <ChevronRightIcon className="w-4 h-4" data-id="element-1041" />
                  </button>
                </div>
              </div>
            </div>

            {/* Card 3: Solar Innovator System */}
            <div className="bg-[#1a1a1a] border border-[#333] flex flex-col relative group" data-id="element-1042">
              {/* Top Border Accent */}
              <div className="absolute top-0 left-0 right-0 h-1 bg-[#c5a059]" data-id="element-1043"></div>

              {/* Image Area */}
              <div className="w-full bg-[#1a1c11] aspect-[4/3] flex items-center justify-center border-b border-[#333]" data-id="element-1044">
                <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1045">
                  <CameraIcon className="w-6 h-6" data-id="element-1046" />
                  <span className="text-xs font-bold tracking-widest" data-id="element-1047">
                    IMAGE HERE
                  </span>
                </div>
              </div>

              {/* Content Area */}
              <div className="p-6 md:p-8 flex flex-col flex-1 justify-between" data-id="element-1048">
                <div className="space-y-4" data-id="element-1049">
                  <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase" data-id="element-1050">
                    <ZapIcon className="w-3 h-3 fill-current text-[#eab308]" data-id="element-1051" />
                    <span data-id="element-1052">Energy Independence</span>
                  </div>

                  <h3 className="text-2xl font-black tracking-tight uppercase" data-id="element-1053">
                    Solar Innovator System
                  </h3>

                  <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1054">
                    A 3D solar sphere inspired by the compound eye of a housefly
                    — built in under 3 hours for around $200. It captures light
                    from nearly every angle, generating up to twice the power of
                    a flat panel in a fraction of the space. No roof required.
                  </p>

                  <ul className="space-y-2 text-sm text-gray-300" data-id="element-1055">
                    <li className="flex items-start gap-2" data-id="element-1056">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1057">
                        ▶
                      </span>
                      <span data-id="element-1058">Cut your electric bill by 50-80%</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1059">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1060">
                        ▶
                      </span>
                      <span data-id="element-1061">Works on a balcony or terrace — 12 sq ft</span>
                    </li>
                    <li className="flex items-start gap-2" data-id="element-1062">
                      <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1063">
                        ▶
                      </span>
                      <span data-id="element-1064">No technical skills required</span>
                    </li>
                  </ul>
                </div>

                <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1065">
                  <div data-id="element-1066">
                    <div className="text-xl font-bold" data-id="element-1067">$39</div>
                    <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1068">
                      Instant Digital Access
                    </div>
                  </div>
                  <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1069">
                    Watch Now <ChevronRightIcon className="w-4 h-4" data-id="element-1070" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Card 4: The Energy Revolution System (Full Width) */}
          <div className="bg-[#1a1a1a] border border-[#333] flex flex-col md:flex-row relative group" data-id="element-1071">
            {/* Left Border Accent */}
            <div className="absolute left-0 top-0 bottom-0 w-1 bg-[#c5a059]" data-id="element-1072"></div>

            {/* Image Area */}
            <div className="w-full md:w-2/5 bg-[#1a1811] min-h-[250px] flex items-center justify-center border-b md:border-b-0 md:border-r border-[#333]" data-id="element-1073">
              <div className="flex flex-col items-center text-gray-600 gap-2" data-id="element-1074">
                <CameraIcon className="w-6 h-6" data-id="element-1075" />
                <span className="text-xs font-bold tracking-widest" data-id="element-1076">
                  IMAGE HERE
                </span>
              </div>
            </div>

            {/* Content Area */}
            <div className="w-full md:w-3/5 p-6 md:p-8 flex flex-col justify-between relative" data-id="element-1077">
              {/* Badge */}
              <div className="absolute top-0 right-0 bg-[#333] text-gray-300 text-[10px] font-bold tracking-widest uppercase px-3 py-1" data-id="element-1078">
                Also Recommended
              </div>

              <div className="space-y-4" data-id="element-1079">
                <div className="flex items-center gap-2 text-[#c5a059] text-xs font-bold tracking-widest uppercase" data-id="element-1080">
                  <BatteryIcon className="w-3 h-3 fill-current text-[#c5a059]" data-id="element-1081" />
                  <span data-id="element-1082">Off-Grid Energy</span>
                </div>

                <h3 className="text-2xl md:text-3xl font-black tracking-tight uppercase" data-id="element-1083">
                  The Energy Revolution System
                </h3>

                <p className="text-gray-400 text-sm leading-relaxed" data-id="element-1084">
                  A century-old device — suppressed for decades — that
                  multiplies any electricity source up to 7 times over. The
                  energy industry tried to bury it. Now it's out in the open,
                  and it could slash your bill by 88% within 30 days.
                </p>

                <ul className="space-y-2 text-sm text-gray-300" data-id="element-1085">
                  <li className="flex items-start gap-2" data-id="element-1086">
                    <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1087">▶</span>
                    <span data-id="element-1088">Based on 100-year-old suppressed technology</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1089">
                    <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1090">▶</span>
                    <span data-id="element-1091">Multiplies any power source up to 7x</span>
                  </li>
                  <li className="flex items-start gap-2" data-id="element-1092">
                    <span className="text-[#c5a059] text-[10px] mt-1" data-id="element-1093">▶</span>
                    <span data-id="element-1094">Runs indefinitely — no fuel, no intervention</span>
                  </li>
                </ul>
              </div>

              <div className="mt-8 pt-6 border-t border-[#333] flex flex-col sm:flex-row items-center justify-between gap-4" data-id="element-1095">
                <div data-id="element-1096">
                  <div className="text-xl font-bold" data-id="element-1097">Under $98</div>
                  <div className="text-xs text-gray-500 tracking-widest uppercase" data-id="element-1098">
                    One-Time Payment · 60-Day Guarantee
                  </div>
                </div>
                <button className="w-full sm:w-auto bg-[#c5a059] hover:bg-[#b08d2c] text-black font-bold text-sm tracking-widest uppercase px-6 py-3 flex items-center justify-center gap-2 transition-colors" data-id="element-1099">
                  Watch The Leaked Video{' '}
                  <ChevronRightIcon className="w-4 h-4" data-id="element-1100" />
                </button>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="border-t border-[#222] py-12 px-4 text-center text-xs text-gray-500 space-y-2" data-id="element-1101">
        <p data-id="element-1102">
          © 2026 Patriots Informer ·{' '}
          <a href="#" className="text-[#c5a059] hover:underline" data-id="element-1103">
            patriotsinformer.com
          </a>
        </p>
        <p className="max-w-2xl mx-auto" data-id="element-1104">
          This page contains affiliate links. If you purchase through these
          links, Patriots Informer may earn a commission at no extra cost to
          you. All products are independently selected and personally
          recommended.
        </p>
      </footer>
    </div>;
}